import type { WeeklyHoursVersion } from './trainingScheduleHistory';

/** A new questionnaire replaces the future schedule; earlier nutrition dates keep their hours. */
export function assessmentWeeklyHours(
  previous: { weeklyHours: number; weeklyHoursHistory?: WeeklyHoursVersion[] },
  weeklyHours: number,
  effectiveFrom: string,
) {
  const history = previous.weeklyHoursHistory?.length
    ? previous.weeklyHoursHistory
    : [{ effectiveFrom: '0000-01-01', weeklyHours: previous.weeklyHours }];
  return {
    weeklyHours,
    weeklyHoursHistory: [
      ...history.filter(version => version.effectiveFrom < effectiveFrom),
      { effectiveFrom, weeklyHours },
    ],
  };
}
